import React, { useState, useEffect, Suspense, lazy } from 'react';
import {Grid} from "@mui/material";
import {CompPartSelector as PartSelector} from "../../components/PartSelector";
import {Application} from "../../application/MainApp";
import {connect} from "react-redux";
import {setBreadcrumbs} from "../root/root.actions";
import {withTranslation} from "react-i18next";
import {OwnMunicipalityReportPage} from "./components/reportOwnMunicipalityPage";
import {DataQueryReportPage} from "./components/reportDataQueryPage";
import {DataQueryMunicipalityReportPage} from "./components/reportDataQueryMunicipalityPage";
import { withRouter } from '../utils/withRouter';

const YouthWorkFiguresReportPage = lazy(() => import("./components/reportYouthWorkFiguresPage"));

const ReportComponent = (props) => {
    const [activeTab, setActiveTab] = useState("ownMunicipality");

    useEffect(() => {
        props.setBreadcrumbs(props.match);

        document.title = `${props.t("common.reports")} - ${props.t("common.title")}`;
    }, []);

    const handleTabChange = (selection) => {
        setActiveTab(selection);
    }

    let page = (<OwnMunicipalityReportPage page={activeTab}/>)
    if(activeTab === "youthWorkFigures") {
        page = (
            <Suspense fallback={<div>LOADING</div>}><YouthWorkFiguresReportPage page={activeTab}/></Suspense>
        )
    }
    if(activeTab === "dataQuery") {
        page = (<DataQueryReportPage page={activeTab}/>)
    }
    if (activeTab === "dataQueryMunicipality") {
        page = (<DataQueryMunicipalityReportPage page={activeTab}/>)
    }

    return (
        <Application>
            <Grid container>
                <Grid className={"MuiGrid-item reportsPage"} size={12}>
                    <PartSelector
                        selectors={[
                            {
                                'key': "ownMunicipality",
                                'label': props.t('report.own_municipality')
                            },
                            {
                                'key': "youthWorkFigures",
                                'label': props.t('report.youth_work_figures')
                            },
                            {
                                'key': "dataQuery",
                                'label': props.t('report.data_query')
                            },
                            {
                                'key': "dataQueryMunicipality",
                                'label': props.t('report.data_query_municipality')
                            }
                        ]}
                        onSelect={handleTabChange}
                    />
                </Grid>
            </Grid>
            {page}
        </Application>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        setBreadcrumbs: (match) => dispatch(setBreadcrumbs(match)),
    };
}


const Report = connect(
    null,
    mapDispatchToProps
)(withTranslation('translation')(withRouter(ReportComponent)));

export {Report};